import type { IV1PageDataOfferCardResponse } from 'shared/repositories/dailyrent/entities/response/V1PageDataOfferCardResponse';

import { EDailyrentDataActionTypes } from '../../actions/dailyrentData';

import type { RootAction } from '../../types/redux/RootAction';

const initialState: IV1PageDataOfferCardResponse = {};

/**
 * Редьюсер для обработки данных посуточной аренды
 */
export function dailyrentDataReducer(
  state: IV1PageDataOfferCardResponse = initialState,
  action: RootAction,
): IV1PageDataOfferCardResponse {
  switch (action.type) {
    case EDailyrentDataActionTypes.Fetched: {
      if (!action.payload) {
        return initialState;
      }

      return action.payload;
    }

    default:
      return state;
  }
}
